import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with the publishable key
// In a real app, this would be an environment variable
let stripePromise;

/**
 * Get the Stripe instance
 * @returns {Promise<Stripe>} - Stripe instance
 */
export const getStripe = () => {
  if (!stripePromise) {
    // Using the actual publishable key
    // In production, use process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    stripePromise = loadStripe('pk_test_51RamcVFMKJcdnraj7IvzGp8ubJmhrkKSryO2vIaQsHPZiHnw1xfxvQOqQyXTIAbQxShmA6zjt1I17d7HS37NTWCh00VYlRMJol');
  }
  return stripePromise;
};

/**
 * Format amount for display
 * @param {number} amount - Amount in cents
 * @param {string} currency - Currency code
 * @returns {string} - Formatted amount
 */
export const formatAmountForDisplay = (amount, currency = 'usd') => {
  const numberFormat = new Intl.NumberFormat(['en-US'], {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
  });
  return numberFormat.format((amount / 100).toFixed(2));
};

/**
 * Format amount for Stripe API
 * @param {number} amount - Amount in dollars
 * @returns {number} - Amount in cents
 */
export const formatAmountForStripe = (amount) => {
  return Math.round(amount * 100);
}; 